import React from "react";
import { Select } from "antd";
import { getAccountBadgeStyles } from "../../utilities/colorUtils";
import { InformationIcon } from "../VirtualizedTable/TableBody/HoverCell";

const CustomSelect = ({
  label,
  name,
  value,
  options,
  disabled,
  onChange,
  disabledOption,
  condition,
  onBlur,
  showIcon,
  form,
  placeholder,
  errors,
  touched,
  style,
  code,
  codeColor,
  showCodeColor,
  labelNotice,
  isSpecialTreso,
  isSpecialCompta,
}) => {
  const commonSelectStyles = {
    width: "100%",
    borderColor: "#000",
    borderWidth: "2px",
    borderStyle: "solid",
    borderRadius: "30px",
    display: "flex",
  };

  const error = errors[name];
  const touch = touched[name];
  const sizeClassName = isSpecialCompta
    ? "half-size-compta"
    : isSpecialTreso
    ? "half-size-treso"
    : "";

  if (!condition) return;
  return (
    <>
      {condition !== null && (
        <div
          className={`wrapper-select ${sizeClassName}`}
          style={style}
        >
          {label && (
            <div className="info-label-wrapper">
              <label htmlFor={name} className="input-text">
                {label}
              </label>
              {name === "type" && (
                <InformationIcon
                  text={
                    <div>
                      Les écritures de simulation peuvent être déplacées
                      librement avec la souris en mode « résultat » . <br />{" "}
                      Pour faire évoluer ensuite le statut de trésorerie vous
                      devrez modifier le type d’écriture à « réelle ».
                    </div>
                  }
                />
              )}
              {labelNotice && <div className="label-notice">{labelNotice}</div>}
            </div>
          )}
          <Select
            placeholder={placeholder}
            name={name}
            value={value || null}
            disabled={disabled}
            size="large"
            bordered={false}
            className={
              value
                ? "form-element-input small"
                : "form-element-input calendar not-filled"
            }
            style={commonSelectStyles}
            onChange={(val) => onChange(name, val)}
            onBlur={onBlur}
          >
            {options.map((option) => (
              <Select.Option
                key={option.key}
                value={option.value}
                disabled={option.value === disabledOption}
                className="option"
              >
                <div
                  className="img-container element-status"
                  style={
                    showIcon ? { background: option.backgroundColor } : null
                  }
                >
                  <div>{option.label}</div>
                  {code && showCodeColor && (
                    <div
                      style={getAccountBadgeStyles(codeColor, {
                        fontWeight: "400",
                        fontSize: "9px",
                        background: codeColor,
                        display: "flex",
                        padding: "2px",
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: "5px",
                        height: "20px",
                        width: "50px",
                      })}
                    >
                      {code}
                    </div>
                  )}
                </div>
              </Select.Option>
            ))}
          </Select>
          {error && touch ? (
            <div className="error-displayer-form-modal">{error}</div>
          ) : null}
        </div>
      )}
    </>
  );
};

export default CustomSelect;
